import { useConstructionMonitoring } from 'composables/constructionMonitoring';
import { useDict } from 'composables/fischerPlugin';
import { defineStore } from 'pinia';

import type {
  ConstructionMonitoringArea,
  ConstructionRoom,
  ConstructionSite,
  SensorBolt,
  SensorDisc,
} from '@/generated/graphql';

export const useConstructionMonitoringStore = defineStore('construction-monitoring', {
  state() {
    return {
      pageType: null as string | null,
      projectId: null as string | null,
      project: null as ConstructionSite | null,
      areaId: null as string | null,
      area: null as ConstructionMonitoringArea | null,
      roomId: null as string | null,
      room: null as ConstructionRoom | null,
      documentId: null as string | null,
      sensorBoltSummary: null as SensorBolt[] | null,
      sensorDiscSummary: null as SensorDisc[] | null,
      isLoading: false as boolean,
    };
  },
  actions: {
    async setPageType(pageType: string) {
      const { loadConstructionMonitoringData, setBrowserPageTitle } = useConstructionMonitoring();
      const dict = useDict();

      this.pageType = pageType;

      if (this.projectId) {
        await loadConstructionMonitoringData();
      }

      let browserTitle = this.room?.name || this.area?.name || this.project?.name || '';

      if (pageType === 'manage-participants') {
        browserTitle =
          dict.get('construction-Projects.Breadcrumb.Manage-Participants') || 'Manage Participants';
      }

      setBrowserPageTitle(browserTitle);
    },
  },
  getters: {
    isOverviewPage(state) {
      return state.pageType === 'overview';
    },
    isProjectPage(state) {
      return state.pageType === 'project';
    },
    isProjectAreaPage(state) {
      return state.pageType === 'area';
    },
    isProjectRoomPage(state) {
      return state.pageType === 'room';
    },
    isManageParticipantsPage(state) {
      return state.pageType === 'manage-participants';
    },
    isAdmin(state) {
      return state.project?.role === 'ADMIN';
    },
    isOffice(state) {
      return state.project?.role === 'OFFICE';
    },
    isAuditor(state) {
      return state.project?.role === 'AUDITOR';
    },
    isEmployee(state) {
      return state.project?.role === 'EMPLOYEE';
    },
    isOwner(state) {
      return state.project?.role === 'OWNER';
    },
    isContributor(state) {
      return state.project?.role === 'CONTRIBUTOR';
    },
    isDemo(state) {
      return state.project?.role === 'DEMO';
    },
  },
});
